module.exports = "<span ng-message=pattern> *Invalid input </span>";